(function () {
    angular.module('facebook-audience-action.dir', ['journey.veil'])
        .directive('facebookAudience', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', 'CANVAS_OPTS', facebookAudience]);

    function facebookAudience($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout, CANVAS_OPTS) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.descriptionEmpty = false;
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function (dummy) {
                    if(!dummy && $scope.connections.isDummy) {
                        delete $scope.connections.isDummy;
                    }

                    //Updates the parent to register its children
                    var parentData = helpers.getConnectionById($scope.connections.parent);
                    if (parentData) {
                        parentData.children = [];
                        parentData.children.push($scope.connections.id);
                        helpers.updateConnections(parentData);
                    }
                    //Save to the global canvas object
                    helpers.updateConnections($scope.connections);

                    if(!$scope.connections.isDummy) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }
                    }

                    var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (index > -1) {
                        $rootScope.unsavedData.splice(index, 1);
                    }

                    //Displays th form data
                    $scope.displayList = false;
                    $rootScope.$emit('hideFacebookAudienceModal');
                    //Displays action menu
                    $scope.displaySubMenu = false;
                    //Save Journey to template
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections),  $scope.isElegibleForUpdate);

                    if ($scope.isElegibleForUpdate && !dummy) {
                        $scope.wasSave = true;
                        $timeout(() => {
                            $scope.wasSave = false;
                        }, 1500);
                    }

                    //Set Back to autoSave
                    $scope.isElegibleForUpdate = true;
                    //Remove Activate Error since its being able to save
                    $scope.displayActivateError = false;
                    $scope.displayErrorBlink = false;

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.setLastElem = function(evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    }
                    else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();

                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideFacebookAudienceModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayFacebookAudienceModal', $scope.connections);
                            } else if ($scope.connections.data.audiances.length == 0 ) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayFacebookAudienceModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideFacebookAudienceModal');
                            }
                            else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideFacebookAudienceModal');
                            }
                        }
                    }
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;
                };

                //Cancel Button
                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        $scope.displayList = false;
                        $rootScope.$emit('hideFacebookAudienceModal');
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayFacebookAudienceModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideFacebookAudienceModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = () => {
                    // last options is for is tip modal.
                    $rootScope.$emit('displayFacebookAudienceModal', $scope.connections, true);
                };


                $scope.$on('closeConfigMenus', function() {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseTitle = function(desc) {
                    if(desc) {
                        const title = JSON.parse(desc);
                        return title.name;
                    }

                    return desc;
                };

                $scope.defineTitle = function(title) {
                    if(title) {
                        if(title === '1') {
                            return 'Add to';
                        }
                        return 'Remove from';
                    }

                    return title;
                };

                $scope.displayModal = function() {
                    $scope.contactListData = $rootScope.contactListData;
                    $scope.modalWindow = true;
                    $rootScope.$emit('displayExtraVeil', true);
                };

                $scope.hideModal = function() {
                    //Hide Menu
                    $scope.modalWindow = false;
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function() {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideActionListModal', function() {
                    if($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        }else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    }else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.$watch('connections', (conn) => {
                    if(conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if(conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function (scope, elem, attr) {

                //Scope data initialization
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    scope.isElegibleForUpdate = false;

                    const template = $templateCache.get('actions/facebook-audience');
                    //Create template and compile it
                    const content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                    });

                    $rootScope.$on('activateFbErr_' + scope.connections.id, function(evt, display) {
                        scope.displayFbActivateError = display;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveActionFacebookAudienceData' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the add new list
                    $rootScope.$on('deleteFBAudienceNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    const fromFb = localStorage.getItem('offToFacebook_' + scope.connections.id);
                    if(fromFb && fromFb === '1') {
                        $timeout(() => {
                            localStorage.removeItem('offToFacebook_' + scope.connections.id);
                            $rootScope.$emit('displayFacebookAudienceModal', scope.connections);
                        }, 500);
                    }

                    if(scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(() => {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000)
                    } else if(scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save(true);
                }

                $(elem).click(function (evt) {
                    //Load Template
                    var template = $templateCache.get('actions/facebook-audience'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    $rootScope.activePlus = false;

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: (lastElement.type == 'RectangleConnection') ? (lastElement.top - 43) : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        data: {audiances: [], action: ''},
                        elemClass: attr.$attr,
                        elemName: 'FacebookAudiance',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                    });

                    $rootScope.$on('activateFbErr_' + scope.connections.id, function(evt, display) {
                        scope.displayFbActivateError = display;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function() {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                        if(scope.displayError) {
                            $timeout(function() {
                                scope.displayList = true;
                                $rootScope.$emit('displayFacebookAudienceModal', scope.connections);
                            }, 250)
                        }
                    });

                    //List modal display new modals
                    $rootScope.$emit('displayFacebookAudienceModal', scope.connections);

                    $rootScope.$on('saveActionFacebookAudienceData' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the add new list
                    $rootScope.$on('deleteFBAudienceNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    scope.contactListData = $rootScope.contactListData;

                    $rootScope.$emit('closeMenus', true);

                    plumbService.connectElements(lastElement, scope.connections);
                });

                scope.deleteElement = function () {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                        $rootScope.activePlus = true;
                    }else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_directives/facebook-audience.js